import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';

/**
 * В организации с доступными локациями рабочая локация обязательна: без неё API
 * отвечает LOCATION_HEADER_REQUIRED. Исключения — маршруты вне организации и
 * экраны, где локацию заводят (`locationOptional`).
 */
export const locationGuard = (to: RouteLocationNormalized): NavigationGuardReturn => {
  if (
    to.name === 'auth.location-switch' ||
    to.meta.requiresOrganization === false ||
    to.meta.locationOptional === true
  ) {
    return true;
  }

  const authStore = useAuthStore();

  if (authStore.currentLocation) {
    return true;
  }

  if (authStore.availableLocations.length === 0) {
    return true;
  }

  console.warn('[locationGuard] Локация не выбрана, редирект на выбор локации', {
    to: to.name,
  });

  return { name: 'auth.location-switch' };
};
